import { CancelButton } from "@circle-react/components/QuickPostV3/Composer/CancelButton";
import { SubmitButton } from "@circle-react/components/QuickPostV3/Composer/SubmitButton";
import { FooterSpaceSelect } from "@circle-react/components/QuickPostV3/Content/FooterSpaceSelect";
import { useRequestClose } from "@circle-react/components/QuickPostV3/contexts/requestCloseContext";

export const Footer = () => {
  const onRequestClose = useRequestClose();

  return (
    <footer
      className="bg-secondary flex h-[68px] shrink-0 items-center justify-between gap-2 px-6 py-4"
      data-testid="quick-post-footer"
    >
      <FooterSpaceSelect />
      <div className="flex shrink-0 items-center gap-2">
        <CancelButton onClick={onRequestClose} />
        <SubmitButton />
      </div>
    </footer>
  );
};
